import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-5" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4 border-b border-divider" }
const _hoisted_3 = { class: "text-base sm:text-lg font-bold text-brown flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-xs px-2 py-0.5 rounded bg-active/10 text-active font-semibold" }
const _hoisted_5 = { class: "flex items-center gap-1 p-1 bg-secondary rounded-xl border border-divider text-xs self-start sm:self-auto" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 md:hidden" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "text-base font-bold text-brown font-caudex" }
const _hoisted_10 = { class: "text-xs text-muted" }
const _hoisted_11 = { class: "flex items-center justify-between text-xs bg-white/80 px-2.5 py-1.5 rounded-lg border border-divider/60" }
const _hoisted_12 = { class: "text-brown" }
const _hoisted_13 = { class: "font-mono text-[11px] text-muted" }
const _hoisted_14 = { class: "flex flex-wrap gap-1 items-center" }
const _hoisted_15 = { class: "text-[11px] pt-1 border-t border-divider/60" }
const _hoisted_16 = { class: "hidden md:block overflow-x-auto" }
const _hoisted_17 = { class: "w-full text-left text-xs border-collapse" }
const _hoisted_18 = { class: "border-b border-divider bg-secondary text-muted uppercase text-[11px]" }
const _hoisted_19 = { class: "py-3 px-3 font-semibold" }
const _hoisted_20 = { class: "py-3 px-3 font-semibold" }
const _hoisted_21 = { class: "py-3 px-3 font-semibold" }
const _hoisted_22 = { class: "py-3 px-3 font-semibold" }
const _hoisted_23 = { class: "py-3 px-3 font-semibold" }
const _hoisted_24 = { class: "py-3 px-3 font-semibold text-right min-w-[117px]" }
const _hoisted_25 = { class: "divide-y divide-divider" }
const _hoisted_26 = { class: "py-3.5 px-3" }
const _hoisted_27 = { class: "font-bold text-brown text-sm font-caudex" }
const _hoisted_28 = { class: "text-[11px] text-muted" }
const _hoisted_29 = { class: "py-3.5 px-3" }
const _hoisted_30 = { class: "font-semibold text-brown" }
const _hoisted_31 = { class: "text-[11px] text-muted font-mono" }
const _hoisted_32 = { class: "py-3.5 px-3" }
const _hoisted_33 = { class: "py-3.5 px-3" }
const _hoisted_34 = { class: "py-3.5 px-3" }
const _hoisted_35 = { class: "space-y-0.5" }
const _hoisted_36 = { class: "py-3.5 px-3 text-right" }

import { computed, ref } from "vue";
import { HourRating, HourReport } from "@/types/calculators";
import HourDaoPathComponent from "@/views/Calculators/PersonalDates/components/dayReport/HourDaoPathComponent.vue";
import RatingBadgeComponent from "@/views/Calculators/PersonalDates/components/dayReport/RatingBadgeComponent.vue";
import SpiritsAndEliteHoursComponent from "@/views/Calculators/PersonalDates/components/dayReport/SpiritsAndEliteHoursComponent.vue";
import TenGodsComponent from "@/views/Calculators/PersonalDates/components/dayReport/TenGodsComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HourlyReportTableComponent',
  props: {
    timeOffset: {},
    hours: {}
  },
  setup(__props: any) {

const props = __props;

const tableRowClasses: Partial<Record<HourRating, string>> = {
  excellent: "bg-[#F6FAF7]",
  bad: "bg-[#FDF9F9]",
};

const currentFiler = ref<"all" | "favourable" | "yellowPath">("all");
const filteredTableRows = computed(() => {
  if (currentFiler.value === "all") {
    return props.hours;
  }
  if (currentFiler.value === "favourable") {
    return props.hours.filter(
      (hour) =>
        hour.personal.personal_rating === "excellent" ||
        hour.personal.personal_rating === "good"
    );
  }
  if (currentFiler.value === "yellowPath") {
    return props.hours.filter(
      (hour) => hour.general.huang_hei_dao.path_type === "HuangDao"
    );
  }
  return [];
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("calculators.personal-date.full-day-report.hourlyTable.title")), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs font-normal text-muted font-caudex" }, " (時辰定局) ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(
                "calculators.personal-date.full-day-report.hourlyTable.solarTimeOffset",
                { offset: __props.timeOffset }
              )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["px-2.5 sm:px-3 py-1 rounded-lg transition-colors", 
            currentFiler.value === 'all'
              ? 'bg-white font-bold text-brown shadow-sm'
              : 'text-muted hover:text-brown'
          ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (currentFiler.value = 'all'))
        }, _toDisplayString(_ctx.$t(
              "calculators.personal-date.full-day-report.hourlyTable.filterAll"
            )), 3),
        _createElementVNode("button", {
          class: _normalizeClass(["px-2.5 sm:px-3 py-1 rounded-lg transition-colors", 
            currentFiler.value === 'favourable'
              ? 'bg-white font-bold text-success shadow-sm'
              : 'text-muted hover:text-brown'
          ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentFiler.value = 'favourable'))
        }, _toDisplayString(_ctx.$t(
              "calculators.personal-date.full-day-report.hourlyTable.filterFavorable"
            )), 3),
        _createElementVNode("button", {
          class: _normalizeClass(["text-muted hover:text-brown px-2.5 sm:px-3 py-1 rounded-lg transition-colors", 
            currentFiler.value === 'yellowPath'
              ? 'bg-white font-bold text-gold shadow-sm'
              : 'text-muted hover:text-brown'
          ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (currentFiler.value = 'yellowPath'))
        }, _toDisplayString(_ctx.$t(
              "calculators.personal-date.full-day-report.hourlyTable.filterYellowPath"
            )), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTableRows.value, (tableRow) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tableRow.hour_index,
          class: _normalizeClass(["p-3.5 rounded-xl border border-divider space-y-2 hover:bg-hover", tableRowClasses[tableRow.personal.personal_rating] ?? ''])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(tableRow.general.gan_zhi), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(tableRow.hour_index) + "." + _toDisplayString(tableRow.general.animal), 1)
            ]),
            _createVNode(RatingBadgeComponent, {
              personalRating: tableRow.personal.personal_rating
            }, null, 8, ["personalRating"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createVNode(_component_i18n_t, {
                keypath: "calculators.personal-date.full-day-report.hourlyTable.absoluteTime",
                class: "text-muted",
                tag: "span"
              }, {
                time: _withCtx(() => [
                  _createElementVNode("strong", _hoisted_12, _toDisplayString(tableRow.time_range_standard), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(
                "calculators.personal-date.full-day-report.hourlyTable.solarTime",
                { time: tableRow.time_range_solar }
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(HourDaoPathComponent, {
              huangHeiDaoInfo: tableRow.general.huang_hei_dao
            }, null, 8, ["huangHeiDaoInfo"]),
            _createVNode(SpiritsAndEliteHoursComponent, {
              general: tableRow.general
            }, null, 8, ["general"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(TenGodsComponent, {
              personal: tableRow.personal
            }, null, 8, ["personal"])
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("table", _hoisted_17, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_18, [
            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colHour"
                )), 1),
            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colTime"
                )), 1),
            _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colPath"
                )), 1),
            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colSpirits"
                )), 1),
            _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colBaziResonance"
                )), 1),
            _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t(
                  "calculators.personal-date.full-day-report.hourlyTable.colRating"
                )), 1)
          ])
        ]),
        _createElementVNode("tbody", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTableRows.value, (tableRow) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: tableRow.hour_index,
              class: _normalizeClass(["transition-colors hover:bg-hover", tableRowClasses[tableRow.personal.personal_rating] ?? ''])
            }, [
              _createElementVNode("td", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(tableRow.general.gan_zhi), 1),
                _createElementVNode("div", _hoisted_28, _toDisplayString(tableRow.hour_index) + "." + _toDisplayString(tableRow.general.animal), 1)
              ]),
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(tableRow.time_range_standard), 1),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t(
                    "calculators.personal-date.full-day-report.hourlyTable.solarTime",
                    { time: tableRow.time_range_solar }
                  )), 1)
              ]),
              _createElementVNode("td", _hoisted_32, [
                _createVNode(HourDaoPathComponent, {
                  huangHeiDaoInfo: tableRow.general.huang_hei_dao
                }, null, 8, ["huangHeiDaoInfo"])
              ]),
              _createElementVNode("td", _hoisted_33, [
                _createVNode(SpiritsAndEliteHoursComponent, {
                  general: tableRow.general
                }, null, 8, ["general"])
              ]),
              _createElementVNode("td", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(TenGodsComponent, {
                    personal: tableRow.personal
                  }, null, 8, ["personal"])
                ])
              ]),
              _createElementVNode("td", _hoisted_36, [
                _createVNode(RatingBadgeComponent, {
                  personalRating: tableRow.personal.personal_rating
                }, null, 8, ["personalRating"])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})